import { Component, OnInit, Inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { languages } from 'src/app/shared/languages';

@Component({
  standalone: false,
  selector: 'app-language-selector-be',
  templateUrl: './language-selector-be.component.html',
  styleUrl: './language-selector-be.component.scss'
})
export class LanguageSelectorBeComponent implements OnInit {
  languages: any[];
  translatedLanguages: any[] = [];

  constructor(
    public translate: TranslateService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    @Inject('LANGUAGES') languages: any[]
  ) { }

  ngOnInit(): void {
    this.languages = languages;
    this.languages = this.languages.filter(lang => lang.code !== 'es_ES' && lang.code !== 'pt_PT');
  }

  selectLanguage(language: string): void {
    this.translate.use(language);
    localStorage.setItem('selectedLanguage', 'Y');
    sessionStorage.setItem('language', language);
    document.documentElement.lang = language.substring(0, 2);
    this.ref.close('cancel');
  }
}